var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgQueue = function SvgQueue(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "queue_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#queue_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M16.001 19.75a2.654 2.654 0 0 1-1.948-.802 2.649 2.649 0 0 1-.803-1.947c0-.763.267-1.413.802-1.948A2.65 2.65 0 0 1 16 14.25c.224 0 .438.029.642.086a1.9 1.9 0 0 1 .608.306V7c0-.212.072-.39.216-.534A.726.726 0 0 1 18 6.25h2.865a.86.86 0 0 1 .626.254c.173.17.259.38.259.63a.853.853 0 0 1-.259.627.853.853 0 0 1-.626.258H18.75V17c0 .764-.267 1.413-.802 1.948a2.65 2.65 0 0 1-1.947.802ZM4 7.75a.725.725 0 0 1-.534-.216A.726.726 0 0 1 3.25 7c0-.213.072-.391.216-.535A.726.726 0 0 1 4 6.25h10c.213 0 .39.072.534.216A.726.726 0 0 1 14.75 7c0 .213-.072.391-.216.535A.726.726 0 0 1 14 7.75H4Zm0 4a.725.725 0 0 1-.534-.216A.726.726 0 0 1 3.25 11c0-.213.072-.391.216-.535A.726.726 0 0 1 4 10.25h10c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.391-.216.535a.726.726 0 0 1-.534.215H4Zm0 4a.725.725 0 0 1-.534-.216A.726.726 0 0 1 3.25 15c0-.213.072-.391.216-.535A.726.726 0 0 1 4 14.25h6c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.391-.216.535a.726.726 0 0 1-.534.215H4Z",
    fill: "currentColor"
  }))));
};
export default SvgQueue;